<div class="text-lg font-semibold mb-3">
  {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.DIALOG.TITEL_PALETTE_AENDERN' | translate}}
</div>

<div class="mb-3">
  <soft-artikel-header
    [palette]="_palette"
    [paletteAendern]="true"
    [bewegung]="_bewegung">
  </soft-artikel-header>
</div>

<div class="font-bold text-sm text-primary-400 mb-1">
  {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.DIALOG.TITEL_MENGE_OFFEN_PALETTE' | translate}}
</div>
<soft-mengen-eingabe
  #palettenMengeOffen
  class="flex w-full mb-3"
  [float]="true"
  [value]="getPaletteArt(_palette)?.menge_offen ?? 0"
  (valueChange)="updateAnzahlPalettenLocal(palettenMengeOffen.value ?? 0)"
  [einheit]="getPaletteArt(_palette)?.arteh?.arteh ?? ''">
</soft-mengen-eingabe>

@if (_bewegung?.bewebs?.artikel?.artikelLlr?.kzpalettenteilung_ek === 'J') {
  <div class="flex flex-row w-full mt-2">
    <div class="font-bold text-sm text-primary-400">
      {{'#LLR_KOMMISSIONIERUNG.ARTIKELDATEN_EINGABE.DIALOG.TITEL_GEWICHT_OFFEN_PALETTE' | translate}}
    </div>
  </div>
  <soft-mengen-eingabe
    #palettenGewichtOffen
    [class]="'w-full mb-3'"
    [float]="true"
    [disabled]="!_gewichtEditable"
    [value]="getPaletteArt(_palette)?.gewicht_offen ?? 0"
    [einheit]="'KG'"
    (valueChange)="updateGewichtLocal(palettenGewichtOffen.value ?? 0)">
  </soft-mengen-eingabe>
}

<div class="flex flex-row w-full gap-2">
  <button
    class="soft-button secondary w-1/2 mt-2 h-14"
    (click)="close(undefined)">
    {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.LABEL_ABBRECHEN' | translate}}
  </button>
  <button
    class="soft-button primary w-1/2 mt-2 h-14"
    (click)="close(_palette)">
    {{'#LLR_KOMMISSIONIERUNG.DIALOG_GLOBAL.LABEL_AENDERUNGEN_SPEICHERN' | translate}}
  </button>
</div>
